import React, {Component} from "react"
import TabLayout, {NavigationRoutes} from "../../util/TabLayout";
import Column from "@amzn/meridian/column";
import {TESSERACT} from "../../util/RouteConstants";
import TesseractDeviceOverviewContextProvider from "./context/TesseractDeviceOverviewContext";

/**
 * Returns the page heading and description
 * @return JSX.Element
 * @param props
 */

class TesseractDevicePage extends Component{
    render() {
        return (
            <Column>
                <TesseractDeviceOverviewContextProvider>
                    <TabLayout routes={TESSERACT} location={this.props.location} history={this.props.history}/>
                    <NavigationRoutes routes={TESSERACT}/>
                </TesseractDeviceOverviewContextProvider>
            </Column>
        )
    }
}

export default TesseractDevicePage;


// WEBPACK FOOTER //
// ./src/components/devicemanagement/tesseract/TesseractDevicePage.js